import React from 'react';
import ListPage from '../../base/ListPage.js';
import APILXD from '../../../http/APILXD.js';
import {Modal, message, Button} from 'antd';
import TimeHelp from "../../../tool/TimeHelp";
import styles from "./DeviceByCondList.less";
import HttpTool from "../../../tool/HttpTool";
import axios from "axios";

class DeviceByCondList extends ListPage {
    constructor(props) {
        super(props);
    }

    base_getListConfig() {
        return {
            table: {
                columns: this.getTableColumns(),
                url: APILXD.getDeviceByCondList,
                otherParam: {
                    ...this.props.requestParams
                },
            },
            toolBar: () => {
                return <div
                    style={{marginBottom: "10px", textAlign: "right"}}
                >
                    <Button
                      type={"primary"}
                      className={styles.toolBtn}
                      onClick={() => {
                          this.exportDeviceByCond()
                      }}>导出设备ID</Button>
                </div>
            },
        }
    }

    exportDeviceByCond(){
        HttpTool.post(APILXD.exportDeviceByCond,(code,msg,json)=>{
            if(!json.key){
                message.warning("无设备可导出")
                return;
            }

            axios({
                method: 'get',
                url: json.key,
                headers: {
                    "Content-Type": "text/plain",
                },
            }).then(({status, data}) => {
                if (status === 200) {
                    Modal.info({
                        title: `设备ID共 ${data.split(",").length} 个`,
                        center: true,
                        width: '80vw',
                        content: <div
                            style={{height:"70vh",wordBreak: 'break-word', whiteSpace: 'pre-wrap', overflow:'auto'}}
                        >
                            {data}
                        </div>
                    })
                } else {
                    message.error("加载数据出错");
                }
            }).catch((err) => {
                message.error('处理出错');
                console.error(err);
            });
        },(code,msg)=>{
            message.error(msg);
        },{...this.props.requestParams})
    }


    /**
     *  列表数据配置
     */
    getTableColumns() {
        return [
            {
                title: '设备号',
                dataIndex: '_id',
                key: '_id',
            },
            {
                title: '机型',
                dataIndex: 'type',
                key: 'type',
                render: (text, record, index) => {
                    let name = "未知";
                    switch (text) {
                        case 2:
                            name = "手机";
                            break;
                        case 3:
                            name = "PC";
                            break;
                        case 4:
                            name = "服务器";
                            break;
                        default:
                            name = "未知";
                    }
                    return <div>
                        {name}
                    </div>
                }
            },
            {
                title: '系统',
                dataIndex: 'romId',
                key: 'romId',
            },
            {
                title: '应用版本',
                dataIndex: 'center',
                key: 'center',
                render: (text, record)=>{
                    return <div>
                        <div>center: {record.center}</div>
                        <div>remote: {record.remote}</div>
                        <div>script: {record.script}</div>
                    </div>
                }
            },
            {
                title: '设备添加时间',
                dataIndex: 'addTime',
                key: 'addTime',
                render: (text) => {
                    let time = "";
                    if (text) {
                        time = TimeHelp.getYMDHMS(text);
                    }
                    return <div>{time}</div>
                }
            },
            {
                title: '最后请求时间',
                dataIndex: 'lasttime',
                key: 'lasttime',
                render: (text) => {
                    let time = "";
                    if (text) {
                        time = TimeHelp.getYMDHMS(text);
                    }
                    return <div>{time}</div>
                }
            },
            // {
            //     title: '安卓版本',
            //     dataIndex: 'SDK',
            //     key: 'SDK',
            // },
            {
                title: '最后请求地点',
                dataIndex: 'location',
                key: 'location',
                render: (text, record, index) => {
                    let countryName = text && text.countryName ? (text.countryName + " ") : "";
                    let provinceName = text && text.provinceName ? (text.provinceName + " ") : "";
                    let cityName = text && text.cityName || "";
                    return <div>{
                        countryName + provinceName + cityName
                    }
                    </div>
                }
            },
            {
                title: '最后请求ip',
                dataIndex: 'ip',
                key: 'ip',
            },

            {
                title: '所属公司',
                dataIndex: 'companyName',
                key: 'companyName',
            },
            {
                title: '状态',
                dataIndex: 'status',
                key: 'status',
                render: (text) => {
                    let map = {
                        "1": {text: "离线", color: "red"},
                        "2": {text: "空闲", color: "green"},
                        "3": {text: "忙碌", color: "blue"},
                        "-1": {text: "未激活", color: "gray"},
                        "null": {text: "未激活", color: "gray"},

                    };
                    let statusMap = map[text + ""];
                    if (!statusMap) {
                        statusMap = {text: "未知", color: "red"}
                    }
                    return <span style={{color: statusMap.color}}>{statusMap.text}</span>
                }
            },
        ]
    }
}

module.exports = DeviceByCondList;